import { render } from "./task-container.vue?vue&type=template&id=16515064"
import script from "./task-container.vue?vue&type=script&lang=js"
export * from "./task-container.vue?vue&type=script&lang=js"

import "./task-container.vue?vue&type=style&index=0&id=16515064&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__